import Dropdown from "../../../../components/inputs/dropdown";
import useTerminals from "../../../../hooks/terminals/useTerminals";

const TerminalsDropdown = ({ onChange, selected, size }) => {
  const { terminals, loading } = useTerminals();
  return (
    <Dropdown
      fullWidth
      name="terminalId"
      label="Terminal"
      onChange={onChange}
      size={size}
      getOptionLabel={(option) => `Terminal ${option?.terminalId}`}
      getOptionValue={(option) => option?.id}
      values={terminals}
      disabled={loading}
      value={selected}
    />
  );
};

export default TerminalsDropdown;
